import gql from "graphql-tag";
import PostOrReplyAuthorFields from "lib/graphql/fragments/engagement/PostOrReplyAuthorFields";
import ReactableFields from "lib/graphql/fragments/ReactableFields";
import PostReplyFields from "../../fragments/engagement/PostReplyFields";

export default gql`
  query PostReplies($postShortId: ID!, $cursor: Cursor, $limit: Int = 8) {
    postByShortId(postShortId: $postShortId) @connection(key: "postByShortId", filter: ["postShortId"]) {
      _id
      shortId
      objectId
      contextKey
      contextType
      bodyAsJson
      bodyAsPlainText
      author {
        ...PostOrReplyAuthorFields
      }
      createdAt

      ... on ForumPost {
        title
        url

        lastRepliedAt
        isPinned
        isLocked

        replyAnswer {
          shortId
          bodyAsJson
          bodyAsPlainText
          createdAt
          author {
            ...PostOrReplyAuthorFields
          }
        }

        ...ReactableFields
      }

      viewerCanViewReplies
      viewerDidAuthor
      viewerCanEdit
      viewerCanDestroy
      viewerCanReply

      replies(limit: $limit, cursor: $cursor) @connection(key: "replies", filter: []) {
        nodes {
          ...PostReplyFields
        }
        totalCount
        pageInfo {
          cursor
          hasNextPage
        }
      }
    }
  }

  ${PostReplyFields}
  ${PostOrReplyAuthorFields}
  ${ReactableFields}
`;
